import { Input, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import './style.less';

interface TableSearchInputProps {
  value: string;
  placeholder: string;
  tooltip: string;
  resetKey?: string | number;
  enterButton?: boolean;
  onSearch: (value: string) => void;
}

const TableSearchInput = ({
  value,
  placeholder,
  tooltip,
  resetKey,
  enterButton = true,
  onSearch,
}: TableSearchInputProps) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    setDraft(value);
  }, [value, resetKey]);

  return (
    <Tooltip title={tooltip}>
      <Input.Search
        className="table-search-input"
        size="middle"
        placeholder={placeholder}
        enterButton={enterButton}
        value={draft}
        onSearch={onSearch}
        onChange={(event) => setDraft(event.target.value)}
        allowClear
      />
    </Tooltip>
  );
};

export default TableSearchInput;
